import React, { useEffect, useContext, useState } from 'react'
import jwtDecode from 'jwt-decode'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import CircularProgress from '@mui/material/CircularProgress'
import { AuthContext } from '../../contexts/Auth'
import { CAvatar, CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle } from '@coreui/react'
import { cilLockLocked } from '@coreui/icons'
import { api } from '../../services/api'
import { saveHistoryAccess } from '../../services/saveHistoryAccess'
import CIcon from '@coreui/icons-react'

import avatar8 from './../../assets/images/avatars/user.png'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const AppHeaderDropdown = () => {
  const { logoutSystem } = useContext(AuthContext)
  const [open, setOpen] = useState(false)
  const [token, setToken] = useState(null)

  useEffect(() => {
    const _token = localStorage.getItem('token')

    if (_token) {
      setToken(_token)
      api.defaults.headers.Authorization = `Bearer ${token}`
    } else {
      const infoToken = jwtDecode(_token)
      saveHistoryAccess(infoToken.userId, 'Logout', 'logout', '', '')
      logoutSystem('')
    }
    // eslint-disable-next-line
  }, [])

  const handleLogout = async () => {
    const infoToken = jwtDecode(token)
    await saveHistoryAccess(infoToken.userId, 'Logout', 'logout', '', '')
    setOpen(logoutSystem('btn'))
  }

  return (
    <>
      <CDropdown variant="nav-item">
        <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
          <CAvatar src={avatar8} size="md" />
        </CDropdownToggle>
        <CDropdownMenu className="pt-0" placement="bottom-end">
          {/* <CDropdownHeader className="bg-light fw-semibold py-2">Account</CDropdownHeader>
          <CDropdownItem href="#">
            <CIcon icon={cilBell} className="me-2" />
            Updates
            <CBadge color="info" className="ms-2">
              42
            </CBadge>
          </CDropdownItem>
          <CDropdownItem href="#">
            <CIcon icon={cilEnvelopeOpen} className="me-2" />
            Messages
            <CBadge color="success" className="ms-2">
              42
            </CBadge>
          </CDropdownItem>
          <CDropdownItem href="#">
            <CIcon icon={cilTask} className="me-2" />
            Tasks
            <CBadge color="danger" className="ms-2">
              42
            </CBadge>
          </CDropdownItem>
          <CDropdownItem href="#">
            <CIcon icon={cilCommentSquare} className="me-2" />
            Comments
            <CBadge color="warning" className="ms-2">
              42
            </CBadge>
          </CDropdownItem>
          <CDropdownHeader className="bg-light fw-semibold py-2">Settings</CDropdownHeader>
          <CDropdownItem href="#">
            <CIcon icon={cilUser} className="me-2" />
            Profile
          </CDropdownItem>
          <CDropdownItem href="#">
            <CIcon icon={cilSettings} className="me-2" />
            Settings
          </CDropdownItem>
          <CDropdownItem href="#">
            <CIcon icon={cilCreditCard} className="me-2" />
            Payments
            <CBadge color="secondary" className="ms-2">
              42
            </CBadge>
          </CDropdownItem>
          <CDropdownItem href="#">
            <CIcon icon={cilFile} className="me-2" />
            Projects
            <CBadge color="primary" className="ms-2">
              42
            </CBadge>
          </CDropdownItem>
          <CDropdownDivider /> */}
          <CDropdownItem
            href="#"
            onClick={() => {
              setOpen(true)
              handleLogout()
            }}
          >
            <CIcon icon={cilLockLocked} className="me-2" />
            Sair
          </CDropdownItem>
        </CDropdownMenu>
      </CDropdown>

      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        /* disableBackdropClick */
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            // Set 'open' to false, however you would do that with your particular code.
            setOpen(false)
          }
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <div className="logo-dialog">
            <img
              src="assets/images/logo.png"
              alt="Logo"
              className="sidebar-brand-full"
              height={35}
            />
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component={'span'}>
            <div className="content-dialog-loading content-dialog-logout">
              <CircularProgress color="secondary" />
              <span className="logout-label">Saindo...</span>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default AppHeaderDropdown
